"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

//fa-chevron-left
var ChevronLeft = function ChevronLeft() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M17.7615461,23.9333772 L33.4582469,40.6350933 C34.2157599,41.4411077 34.1737454,42.7060734 33.3644051,43.4604733 C32.5550647,44.2148732 31.2848792,44.1730314 30.5273663,43.3670171 L13.5417462,25.2938559 C12.8173041,24.5230298 12.8197107,23.324044 13.5472414,22.5561084 L30.5328615,4.6271577 C31.293604,3.8241658 32.5639474,3.78738156 33.3702528,4.54499779 C34.1765582,5.30261402 34.2134943,6.56773687 33.4527517,7.37072877 L17.7615461,23.9333772 Z"
  }));
};

ChevronLeft.displayName = 'ChevronLeft';
var _default = ChevronLeft;
exports["default"] = _default;
ChevronLeft.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ChevronLeft"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/ChevronLeft.js"] = {
    name: "ChevronLeft",
    docgenInfo: ChevronLeft.__docgenInfo,
    path: "src/ChevronLeft.js"
  };
}